  
  
  const decodeBase64 :any= function (encodedString:any) {
    return new Buffer(encodedString, "base64").toString();
  };
  export default decodeBase64;